import "./NotFoundPage.scss";
import chatimage from "../assets/errorimage/chat404.svg";
import arrowimage from "../assets/errorimage/yellowarrow.svg";

const openIntercom = () => {
  if (typeof window === "undefined") {
    return;
  }

  const intercomFn = (window as typeof window & {
    Intercom?: (command: string) => void;
  }).Intercom;

  if (typeof intercomFn === "function") {
    intercomFn("show");
  }
};

export default function NotFoundPage() {
  return (
    <div className="not-found-page">
      <div className="not-found-page__inner">
        <div className="not-found-page__bg-text-wrapper">
          <div className="not-found-page__bg-text" aria-hidden="true">
            404 404
          </div>
        </div>

        <div className="not-found-page__container">
          <div className="not-found-page__row">
            <div className="not-found-page__left">
              <div className="not-found-page__bubble-wrapper">
                <div className="not-found-page__bubble">
                  <div className="not-found-page__bubble-text">
                    <p>What’s a user like you, doing on a page like this?</p>
                  </div>
                </div>
              </div>

              <h1 className="not-found-page__title">{"Well, \nHello There"}</h1>

              <div className="not-found-page__description">
                {`Did your favorite bookmarked link expire? 
Perhaps you typed too quickly in the URL bar. Or, 
like bad poetry, mistakes happen. Since you're 
here, check out this 404, AI-inspired poem, then 
pop over to Intercom for help.`}
              </div>

              <div className="not-found-page__poem">
                {`Clicked a link, what did I see?
404! No page for me. 
Polar bears in snow so white, 
Guess I'll watch them play all night!`}
              </div>
            </div>

            <div className="not-found-page__right">
              <div className="not-found-page__illustration-wrapper">
                <img src={arrowimage} alt="" />
                <div
                  className="not-found-page__cta"
                  role="button"
                  tabIndex={0}
                  onClick={openIntercom}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      e.preventDefault();
                      openIntercom();
                    }
                  }}
                >
                  <div className="not-found-page__cta-shape">
                    <div className="not-found-page__cta-label">Ask Intercom</div>
                  </div>
                </div>
              </div>
              <img src={chatimage} alt="" />
            </div>
          </div>
        </div>

        <div className="not-found-page__footer">
          <div className="not-found-page__footer-curve" />
        </div>
      </div>
    </div>
  );
}